import { cn } from '../../lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'bitte-animate-pulse bitte-rounded-md bitte-bg-primary/10',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
